<section class="title-bar content-padding first-item ">
    <div class="wrapper nowrap">
        <h2 class="title-heading">
            {{ customVendita?.id ? "MODIFICA" : "NUOVA" }}
            CUSTOM VENDITA
            <span *ngIf="customVendita?.platform">[{{ customVendita.platform.toUpperCase() }}]</span>
            <span *ngIf="customVendita?.id">#{{ customVendita.id }}</span>
        </h2>
        <div class="item nowrap">
            <span class="data-row-left btn-container top-button-container">
                <button class="btn hvr-shrink vertical align-items-center" *ngIf="customVendita?.id" (click)="generatePaymentLink()">
                    <ng-container *ngIf="!isLoading">
                        Generate Payment Link&nbsp;<i class="ml-10 fas fa-link"></i>
                    </ng-container>
                    <ng-container *ngIf="isLoading">
                        Generating...&nbsp;<i class="fas fa-spinner fa-spin"></i>
                    </ng-container>
                </button>
            </span>
        </div>
    </div>
</section>

<section id="modificaConsegna" class="content-padding">
    <div class="narrow-wrapper">
        <form class="has-cols" [formGroup]="customSaleForm" (ngSubmit)="onSubmit()" *ngIf="customSaleForm">

            <div class="delivery-colle-data-box">
                <fieldset>
                    <legend>Data consegna</legend>

                    <div class="col-40 grid-element">
                        <label>Data consegna{{ customSaleForm.get("deliveryDate") | required }}</label>
                        <input type="date" formControlName="deliveryDate">
                        <app-error-html-handler [ctrl]="customSaleForm.get('deliveryDate')" [messages]="formValidationMsgs.deliveryDate"></app-error-html-handler>
                    </div>
                    <br class="clear">

                    <div class="col-48 grid-element">
                        <label>SELECT PLATFORM{{ customSaleForm.get("platform") | required }}</label>
                        <select formControlName="platform">
                            <option value="shopifysale">Deluxy Vendita</option>
                            <option value="cakesales">Cake Vendita</option>
                            <option value="flowerssales">Flowers Vendita</option>
                            <option value="businesssales">Business Vendita</option>
                            <option value="deluxyexperiencesales">Deluxy Experience Vendita</option>
                            <option value="deluxydotcomsales">Deluxy Dot Com Vendita</option>
                        </select>
                        <app-error-html-handler [ctrl]="customSaleForm.get('platform')" [messages]="formValidationMsgs.platform"></app-error-html-handler>
                    </div>
                    <br class="clear">

                    <div class="col-48 grid-element">
                        <label></label>
                        <label class="original-label">
                        <input type="checkbox" formControlName="isFlexbleDeliveryTime">
                            Flessibile Fascia Oraria Consegna
                        </label>
                    </div>

                    <div class="col-48 grid-element">
                        <label>FASCIA ORARIA CONSEGNA{{ customSaleForm.get("deliveryTime") | required }}</label>
                        <div class="time-range" [ngClass]="{'hidden': customSaleForm.get('isFlexbleDeliveryTime').value}">
                            <select formControlName="deliveryTime">
                                <option value="07:00-08:00">07:00-08:00</option>
                                <option value="08:00-09:00">08:00-09:00</option>
                                <option value="09:00-10:00">09:00-10:00</option>
                                <option value="10:00-11:00">10:00-11:00</option>
                                <option value="11:00-12:00">11:00-12:00</option>
                                <option value="12:00-13:00">12:00-13:00</option>
                                <option value="13:00-14:00">13:00-14:00</option>
                                <option value="14:00-15:00">14:00-15:00</option>
                                <option value="15:00-16:00">15:00-16:00</option>
                                <option value="16:00-17:00">16:00-17:00</option>
                                <option value="17:00-18:00">17:00-18:00</option>
                                <option value="18:00-19:00">18:00-19:00</option>
                                <option value="19:00-20:00">19:00-20:00</option>
                                <option value="20:00-21:00">20:00-21:00</option>
                                <option value="21:00-22:00">21:00-22:00</option>
                            </select>
                        </div>
                        <div class="time-range" [ngClass]="{'hidden': !customSaleForm.get('isFlexbleDeliveryTime').value}">
                            <div>
                                <input type="time" [(ngModel)]="deliveryFTime" [ngModelOptions]="{standalone: true}" (ngModelChange)="handleDeliveryFlexbleTime()">
                                <div *ngIf="deliveryFTimeError" style="color: red; font-size: small;">Obbligatorio</div>
                            </div>
                            <div style="text-align: center;">&nbsp;-&nbsp;</div>
                            <div>
                                <input type="time" [(ngModel)]="deliveryTTime" [ngModelOptions]="{standalone: true}" (ngModelChange)="handleDeliveryFlexbleTime()">
                                <div *ngIf="deliveryTTimeError" style="color: red; font-size: small;">Obbligatorio</div>
                            </div>
                        </div>
                        <app-error-html-handler [ctrl]="customSaleForm.get('deliveryTime')" [messages]="formValidationMsgs.deliveryTime"></app-error-html-handler>
                    </div>
                </fieldset>
            </div>

            <div class="delivery-colle-data-box" style="margin-top: 15px;">
                <fieldset>
                    <legend>DETAGLI DEL DESTINATARIO</legend>

                    <div class="grid-element-full">
                        <label>Indirizzo destinatario{{ customSaleForm.get("address") | required }}
                          <span class="directions" (click)="directions($event)"> <i class="fas fa-directions fa-2x"></i></span>
                        </label>
                        <app-google-maps-search (setAddress)="getAddress($event)" addressType="geocode" [control]="customSaleForm.get('address')"></app-google-maps-search>
                        <app-error-html-handler [ctrl]="customSaleForm.get('address')" [messages]="formValidationMsgs.address"></app-error-html-handler>
                    </div>

                    <div class="col-48 grid-element">
                        <label for="existingCustomer"></label>
                        <label class="original-label">
                            <input type="checkbox" name="existingCustomer" formControlName="existingCustomer" (change)="handleExistingCustomer($event)">
                            CHOOSE EXISTING CUSTOMER
                        </label>
                    </div>

                    <br class="clear" *ngIf="customSaleForm.get('existingCustomer').value">

                    <div class="col-48 grid-element" [ngClass]="{'hidden': !customSaleForm.get('existingCustomer').value}">
                        <label>Customer</label>
                        <ng-select 
                            bindLabel="name" 
                            bindValue="id" 
                            formControlName="customer" 
                            (change)="handleCustomerChange($event)"
                            [searchable]="true" 
                            [clearable]="true"
                            [virtualScroll]="true"
                        >
                            <ng-option *ngFor="let customer of customers" [value]="customer.id">
                                {{ customer.user.surname }} {{ customer.user.name }}
                            </ng-option>
                        </ng-select>
                        <app-error-html-handler [ctrl]="customSaleForm.get('customer')" [messages]="formValidationMsgs.customer"></app-error-html-handler>
                    </div>

                    <div class="col-48 grid-element" [ngClass]="{'hidden': customSaleForm.get('existingCustomer').value }">
                        <label for="newCustomer"></label>
                        <label class="original-label">
                            <input type="checkbox" name="newCustomer" [(ngModel)]="newCustomer" [ngModelOptions]="{standalone: true}">
                            SAVE CUSTOMER
                        </label>
                    </div>

                    <div class="col-48 grid-element">
                        <label>Cognome destinatario{{ customSaleForm.get("lastName") | required }}</label>
                        <input type="text" formControlName="lastName">
                        <app-error-html-handler [ctrl]="customSaleForm.get('lastName')" [messages]="formValidationMsgs.lastName"></app-error-html-handler>
                    </div>
        
                    <div class="col-48 grid-element">
                        <label>Nome destinatario{{ customSaleForm.get("firstName") | required }}</label>
                        <input type="text" formControlName="firstName">
                        <app-error-html-handler [ctrl]="customSaleForm.get('firstName')" [messages]="formValidationMsgs.firstName"></app-error-html-handler>
                    </div>
                        
                    <div class="col-48 grid-element">
                        <label>Email destinatario{{ customSaleForm.get("receiverEmail") | required }}</label>
                        <input type="text" formControlName="receiverEmail">
                        <app-error-html-handler [ctrl]="customSaleForm.get('receiverEmail')" [messages]="formValidationMsgs.receiverEmail"></app-error-html-handler>
                    </div>

                    <div class="col-48 grid-element">
                        <label>Citofono{{ customSaleForm.get("intercom") | required }}</label>
                        <input type="text" formControlName="intercom">
                        <app-error-html-handler [ctrl]="customSaleForm.get('intercom')" [messages]="formValidationMsgs.intercom"></app-error-html-handler>
                    </div>
        
                    <div class="col-48 grid-element">
                        <label>Telefono destinatario</label>
                        <input type="text" placeholder="+449878487878" formControlName="phone">
                        <app-error-html-handler [ctrl]="customSaleForm.get('phone')" [messages]="formValidationMsgs.phone"></app-error-html-handler>
                    </div>
                </fieldset>
            </div>

            <div class="delivery-colle-data-box" style="margin-top: 15px;">
                <fieldset>
                    <legend>MINTTENTE DEL DESTINATARIO</legend>

                    <div class="col-48 grid-element">
                        <label>Cognome mittente</label>
                        <input type="text" formControlName="senderSurname">
                    </div>
        
                    <div class="col-48 grid-element">
                        <label>Nome mittente</label>
                        <input type="text" formControlName="senderName">
                    </div>
        
                    <div class="col-48 grid-element">
                        <label>Telefono mittente</label>
                        <input type="text" formControlName="senderPhone">
                        <app-error-html-handler [ctrl]="customSaleForm.get('senderPhone')" [messages]="formValidationMsgs.senderPhone"></app-error-html-handler>
                    </div>
                </fieldset>
            </div>

            <div class="delivery-colle-data-box" style="margin-top: 15px;">
                <fieldset>
                    <legend>PRODOTTO</legend>
                    <div class="grid-element-full">
                        <div formArrayName="deliveryProducts">
                            <div class="offer-products" *ngFor="let productForm of customSaleForm.get('deliveryProducts').controls; let i = index">
                                <fieldset style="margin-bottom: 10px;" class="product-fieldset">
                                    <div [formGroupName]="i" class="mb-5 mob-padding-horizontal" style="display: table; width: 100%; ">
                                        <div style="display: table-cell; width: 19px;">
                                            <i class="far fa-times-circle hvr-grow remove-product"  (click)="removeProduct(i)"></i>
                                        </div>
                                        <div class="product-q" formGroupName="product">
                                            <div class="porduct-qty">

                                                <div class="grid-element-full-partner">
                                                    <label for="partner">Partner</label>
                                                    <ng-select 
                                                        bindLabel="name" 
                                                        hideSelected="true" 
                                                        bindValue="id" 
                                                        formControlName="partner" 
                                                        (change)="handlePartnerChange(i, $event)"
                                                        [searchable]="true" 
                                                        [clearable]="true"
                                                        [virtualScroll]="true"
                                                    >
                                                        <ng-option *ngFor="let partner of partners" [value]="partner.id">
                                                            {{ partner.businessName }}
                                                        </ng-option>
                                                    </ng-select>
                                                    <app-error-html-handler
                                                        [ctrl]="productForm.controls.product.controls.partner"
                                                        [messages]="[{type:'required', message:'Obbligatorio'}]">
                                                    </app-error-html-handler>

                                                    <ng-container *ngIf="getPartnerPickupAddresses(i).length > 0">
                                                        <div *ngIf="selectedPickupAddresses[i]" class="amp-selected-address-display">
                                                            <i class="fas fa-map-marker-alt"></i>
                                                            <span>{{ selectedPickupAddresses[i] }}</span>
                                                        </div>

                                                        <button 
                                                            type="button" 
                                                            class="btn mt-5"
                                                            (click)="openPickupAddressModal(i)">
                                                            <i class="fas fa-map-marker-alt ml-5"></i>
                                                            {{ selectedPickupAddresses[i] ? 'Cambia Indirizzo Ritiro' : 'Indirizzo Ritiro' }}
                                                        </button>
                                                    </ng-container>
                                                </div>

                                                <div class="saifu-input">
                                                    <label>Prodotto</label>
                                                    <ng-select 
                                                        bindLabel="name" 
                                                        hideSelected="true" 
                                                        bindValue="id" 
                                                        formControlName="id" 
                                                        (change)="handleProductChange(i, $event)"
                                                        [searchable]="true" 
                                                        [clearable]="true"
                                                        [virtualScroll]="true"
                                                    >
                                                        <ng-option *ngFor="let product of products | sortProducts:selectedPartnerIds[i]" [value]="product.id">
                                                            <b *ngIf="product?.partner?.id === selectedPartnerIds[i]">
                                                                {{ product.name }}
                                                            </b>

                                                            <span *ngIf="product?.partner?.id !== selectedPartnerIds[i] || !product?.partner">
                                                                {{ product.name }}
                                                            </span>
                                                        </ng-option>
                                                    </ng-select>
                                                    <app-error-html-handler
                                                        [ctrl]="productForm.controls.product.controls.id"
                                                        [messages]="formValidationMsgs.deliveryProducts.product.id">
                                                    </app-error-html-handler>
                                                </div>
                                                
                                                <div class="saifu-input">
                                                    <label>Quantità</label>
                                                    <input type="number" formControlName="quantity" placeholder="Product quantity" (input)="handleProductQuantityChange()">
                                                    <app-error-html-handler
                                                        [ctrl]="productForm.controls.product.controls.quantity"
                                                        [messages]="formValidationMsgs.deliveryProducts.product.quantity">
                                                    </app-error-html-handler>
                                                </div>

                                                <div class="saifu-input">
                                                    <label for="">Prodotto Immagine</label>

                                                    <input
                                                        type="file"
                                                        accept="image/*"
                                                        (change)="onImageSelected($event, i)"
                                                        *ngIf="!productForm.get('product.productImage').value"
                                                    />

                                                    <div *ngIf="productForm.get('product.productImage').value" class="product-image-wrapper">
                                                        <img
                                                            [src]="previewUrls[i] || getImageUrl(productForm.get('product.productImage').value)"
                                                            class="product-image"
                                                            alt="Product Image"
                                                            height="60"
                                                            width="60"
                                                        />
                                                        <button type="button" (click)="removeImage(i)" class="remove-btn">
                                                            <i class="far fa-times-circle hvr-grow"></i>
                                                        </button>
                                                    </div>
                                                </div>

                                                <div class="col-48 grid-element">
                                                    <label for="hiddenProduct"></label>
                                                    <label class="original-label">
                                                    <input 
                                                        type="checkbox" 
                                                        name="hiddenProduct"
                                                        formControlName="hiddenProduct"
                                                        (change)="updateHiddenProduct(i, $event.target.checked)"
                                                        [disabled]="isHiddenProductDisabled(i)"
                                                        [checked]="productForm.get('product.hiddenProduct')?.value" 
                                                    >
                                                    PRODOTTO NASCOSTO
                                                    </label>
                                                </div>

                                                <div class="grid-element-full-partner">
                                                    <label for="">Prodotto Note</label>
                                                    <textarea rows="5" formControlName="productNote" placeholder=""></textarea>
                                                </div>

                                                <div class="saifu-input">
                                                    <label>Prezzo</label>
                                                    <input type="number" step="0.01" min="0" formControlName="productPrice">
                                                    <app-error-html-handler
                                                        [ctrl]="productForm.controls.product.controls.productPrice"
                                                        [messages]="formValidationMsgs.deliveryProducts.product.productPrice">
                                                    </app-error-html-handler>
                                                </div>

                                                <div class="saifu-input">
                                                    <label>Prezzo Pubblico</label>
                                                    <input type="number" step="0.01" min="0" formControlName="productPublicPrice">
                                                    <app-error-html-handler
                                                        [ctrl]="productForm.controls.product.controls.productPublicPrice"
                                                        [messages]="formValidationMsgs.deliveryProducts.product.productPublicPrice">
                                                    </app-error-html-handler>
                                                </div>

                                            </div>
                                        </div>
                                        <fieldset class="variant-fieldset" *ngIf="showProductVariant[i]">
                                            <legend><b>{{ selectedProductsForVariants[i]?.productOptionTitle?.toUpperCase() }}</b></legend>
                                            <div class="product-variants">
                                                <span 
                                                    class="chip primary"
                                                    [ngClass]="{ 'variant-selected': variant === selectedVariants[i] }"
                                                    *ngFor="let variant of selectedProductsForVariants[i]?.productVariants"
                                                    (click)="onVariantSelect(i, variant)"
                                                >
                                                {{ variant?.variantName || "---"}}
                                                </span>
                                            </div>
                                        </fieldset>
                                    </div>
                                </fieldset>
                            </div>
                        </div>
                        <div class="center" style="width: 100%;">
                            <button type="button" class="btn mt-0" (click)="$event.preventDefault(); addProduct()">
                                Aggiungi prodotto<i class="ml-10 fas fa-plus"></i>
                            </button>
                        </div>
                    </div>

                    <div class="col-48 grid-element">
                        <label>COSTO CONSEGNE</label>
                        <input type="text" formControlName="totalShippingAmount" (input)="updateAllTotals()">
                        <app-error-html-handler [ctrl]="customSaleForm.get('totalShippingAmount')" [messages]="formValidationMsgs.totalShippingAmount"></app-error-html-handler>
                    </div>

                    <div class="col-48 grid-element">
                        <label>PREZZO PUBBLICO</label>
                        <input type="text" formControlName="totalLineItemsPrice">
                        <app-error-html-handler [ctrl]="customSaleForm.get('totalLineItemsPrice')" [messages]="formValidationMsgs.totalLineItemsPrice"></app-error-html-handler>
                    </div>

                    <div class="col-48 grid-element">
                        <label>VALORE VENDITE</label>
                        <input type="text" formControlName="totalPrice">
                        <app-error-html-handler [ctrl]="customSaleForm.get('totalPrice')" [messages]="formValidationMsgs.totalPrice"></app-error-html-handler>
                    </div>

                    <div class="col-48 grid-element">
                        <label>Totale</label>
                        <input type="text" formControlName="total">
                        <app-error-html-handler [ctrl]="customSaleForm.get('total')" [messages]="formValidationMsgs.total"></app-error-html-handler>
                    </div>
                    
                    <div class="col-48 grid-element">
                        <label>Stato del pagamento</label>
                        <select formControlName="customSalePaymentStatus">
                            <option *ngFor="let item of customSalePaymentStatus | enumToArray" value="{{ item.name }}">
                                {{ customSalePaymentStatusAux.ln('it', item.name) }}
                            </option>
                        </select>
                    </div>
        
                    <div class="col-48 grid-element">
                        <label>Stato di completamento</label>
                        <select formControlName="customSaleFulfillmentStatus">
                            <option *ngFor="let item of customSaleFulfillmentStatus | enumToArray" value="{{ item.name }}">
                                {{ customSaleFulfillmentStatusAux.ln('it', item.name) }}
                            </option>
                        </select>
                    </div>

                    <div class="grid-element-full">
                        <label>Note</label>
                        <textarea formControlName="notes" rows="5" placeholder=""></textarea>
                    </div>

                    <div class="grid-element-full">
                        <label>Testo Per Il Biglietto Di Auguri</label>
                        <textarea formControlName="greetingNote" rows="5" placeholder=""></textarea>
                    </div>
                </fieldset>
            </div>

            <div class="center mt-20">
                <button class="btn hvr-shrink center" (click)="$event.preventDefault(); onSubmit()" [disabled] ="!customSaleForm.valid || disabledBtn">
                    Salva Vendita<i class="ml-10 far fa-save"></i>
                </button>
            </div>

            <div class="error-box mt-3" *ngIf="getErrorMessages().length > 0">
                <fieldset>
                    <legend><strong>CAMPI OBBLIGATORI:</strong></legend>
                    <ul class="error-list">
                        <li *ngFor="let error of getErrorMessages()">
                            {{ translateErrorMessage(error) }}
                        </li>
                    </ul>
                </fieldset>
            </div>

        </form>
    </div>
</section>

<div *ngIf="showAddressModal && selectedPartner" class="amp-backdrop">
  <div class="amp-box">
    <div class="amp-header">
      <div class="amp-badge">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
          <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0118 0z"/><circle cx="12" cy="10" r="3"/>
        </svg>
        Indirizzi Multipli
      </div>
      <h3 class="amp-title">
        <span class="amp-partner-name">{{ selectedPartner.businessName }}</span> ha più indirizzi salvati
      </h3>
      <p class="amp-subtitle">Seleziona un indirizzo di ritiro per proseguire con questo ordine.</p>
    </div>

    <div class="amp-divider"></div>

    <div class="amp-default-block">
      <div class="amp-default-header">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0118 0z"/><circle cx="12" cy="10" r="3"/>
        </svg>
        <span>Indirizzo Predefinito</span>
        <span class="amp-default-tag">Predefinito</span>
      </div>
      <p class="amp-default-address">{{ selectedPartner.address }}</p>
    </div>

    <div class="amp-section-label">Seleziona un indirizzo alternativo</div>

    <div class="amp-list">
      <label
        *ngFor="let addr of selectedPartner.pickupAddresses"
        class="amp-item"
        [class.amp-item--selected]="selectedPickupAddress === addr"
        [class.amp-item--disabled]="isConfirming">
        <input
          type="radio"
          [value]="addr"
          [(ngModel)]="selectedPickupAddress"
          [disabled]="isConfirming">
        <div class="amp-radio-dot">
          <div class="amp-radio-inner"></div>
        </div>
        <div class="amp-address-text">
          <span class="amp-address-label">{{ addr }}</span>
        </div>
        <svg class="amp-pin-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0118 0z"/><circle cx="12" cy="10" r="3"/>
        </svg>
      </label>
    </div>

    <div class="amp-footer">
      <button type="button" class="amp-btn amp-btn--cancel" (click)="handleModalBox()" [disabled]="isConfirming">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/>
        </svg>
        Annulla
      </button>
      <button type="button" class="amp-btn amp-btn--confirm" (click)="confirmCustomPickUpAddress()" [disabled]="isConfirming || !selectedPickupAddress">
        <span *ngIf="isConfirming" class="amp-spinner"></span>
        <ng-container *ngIf="!isConfirming">
          Conferma Indirizzo
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
            <polyline points="20 6 9 17 4 12"/>
          </svg>
        </ng-container>
        <ng-container *ngIf="isConfirming">
          Caricamento...
        </ng-container>
      </button>
    </div>
  </div>
</div>